/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { Evento } from '../model/evento';
import { EventoBase } from '../model/eventoBase';
import { EventoPatch } from '../model/eventoPatch';
import { FotoEvento } from '../model/fotoEvento';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class EventosService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Elimina un evento.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEmpresaByIdEventoById(empresaId: string, eventoId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEmpresaByIdEventoById(empresaId: string, eventoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEmpresaByIdEventoById(empresaId: string, eventoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEmpresaByIdEventoById(empresaId: string, eventoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling deleteEmpresaByIdEventoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling deleteEmpresaByIdEventoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion de la foto.
     * Obtiene informacion de la foto con el id especificado.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param fotoId El id de la foto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling deleteEmpresaByIdEventosByIdFotoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling deleteEmpresaByIdEventosByIdFotoById.');
        }
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling deleteEmpresaByIdEventosByIdFotoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene el detalle de un evento por su id.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdEventoById(empresaId: string, eventoId: string, observe?: 'body', reportProgress?: boolean): Observable<Evento>;
    public getEmpresaByIdEventoById(empresaId: string, eventoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Evento>>;
    public getEmpresaByIdEventoById(empresaId: string, eventoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Evento>>;
    public getEmpresaByIdEventoById(empresaId: string, eventoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdEventoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresaByIdEventoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Evento>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las fotos del evento.
     * Obtiene las fotos del evento.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FotoEvento>>;
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FotoEvento>>>;
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FotoEvento>>>;
    public getEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdEventoByIdFotos.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresaByIdEventoByIdFotos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<FotoEvento>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene el listing de personas.
     * Permite descargar el listin de personas.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param attachment Especifica el disposition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdEventoByIdListing(empresaId: string, eventoId: string, attachment?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getEmpresaByIdEventoByIdListing(empresaId: string, eventoId: string, attachment?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getEmpresaByIdEventoByIdListing(empresaId: string, eventoId: string, attachment?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getEmpresaByIdEventoByIdListing(empresaId: string, eventoId: string, attachment?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdEventoByIdListing.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresaByIdEventoByIdListing.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (attachment !== undefined && attachment !== null) {
            queryParameters = queryParameters.set('attachment', <any>attachment);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/listing`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion de la foto.
     * Obtiene informacion de la foto con el id especificado.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param fotoId El id de la foto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'body', reportProgress?: boolean): Observable<FotoEvento>;
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FotoEvento>>;
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FotoEvento>>;
    public getEmpresaByIdEventosByIdFotoById(empresaId: string, eventoId: string, fotoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdEventosByIdFotoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresaByIdEventosByIdFotoById.');
        }
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling getEmpresaByIdEventosByIdFotoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<FotoEvento>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de eventos paginadas. por defecto se ordenan en orden descendiente de creacion.
     * Al obtener los eventos puede especificar una paginacion y orden para mostrarlo.
     * @param empresaId Especifica la empresaid.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdEventos(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Evento>>;
    public getEmpresasByIdEventos(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Evento>>>;
    public getEmpresasByIdEventos(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Evento>>>;
    public getEmpresasByIdEventos(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdEventos.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Evento>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param eventoPatch Solicitud de Patch sobre el evento.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchEmpresaByIdEventoById(empresaId: string, eventoId: string, eventoPatch?: EventoPatch, observe?: 'body', reportProgress?: boolean): Observable<EventoPatch>;
    public patchEmpresaByIdEventoById(empresaId: string, eventoId: string, eventoPatch?: EventoPatch, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventoPatch>>;
    public patchEmpresaByIdEventoById(empresaId: string, eventoId: string, eventoPatch?: EventoPatch, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventoPatch>>;
    public patchEmpresaByIdEventoById(empresaId: string, eventoId: string, eventoPatch?: EventoPatch, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling patchEmpresaByIdEventoById.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling patchEmpresaByIdEventoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<EventoPatch>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}`,
            eventoPatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sube una foto o recurso asocida a un Evento.
     * Permite subir una fotos o un conjunto de fotos.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param fotoFile 
     * @param fotoUri 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postEmpresaByIdEventoByIdFotos(empresaId: string, eventoId: string, fotoFile?: Blob, fotoUri?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresaByIdEventoByIdFotos.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling postEmpresaByIdEventoByIdFotos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (fotoFile !== undefined) {
            formParams = formParams.append('fotoFile', <any>fotoFile) as any || formParams;
        }
        if (fotoUri !== undefined) {
            formParams = formParams.append('fotoUri', <any>fotoUri) as any || formParams;
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/fotos/`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un nuevo evento, en estado borrador.
     * Crea un nuevo evento. El evento es creado en estado borrador. Para permitir su edicion y cambio de estado.
     * @param empresaId Especifica la empresaid.
     * @param eventoBase Un Objeto JSON que representa la informacion del Evento a crear.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresasByIdEventos(empresaId: string, eventoBase?: EventoBase, observe?: 'body', reportProgress?: boolean): Observable<Evento>;
    public postEmpresasByIdEventos(empresaId: string, eventoBase?: EventoBase, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Evento>>;
    public postEmpresasByIdEventos(empresaId: string, eventoBase?: EventoBase, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Evento>>;
    public postEmpresasByIdEventos(empresaId: string, eventoBase?: EventoBase, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresasByIdEventos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Evento>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/`,
            eventoBase,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
